<template>
    <div>
        <img src="https://alistatic.54traveler.com/werulepc/page2/pc2-1.jpg" style="width:100%;min-width:1000px;">
        <div class="container">
            <div class="row" style="margin-bottom: 20px;">
                <h2>城市是什么：</h2>
                <p class="text-muted" style="width: 95%;" id="texta" v-show="!textShow">
                    C城市是诞生奇迹之所， 是人类最伟大的发明与最美好的希望。
                    钢筋水泥的高楼之下，是平凡治愈的人间烟火；
                    灯红酒绿的霓虹之外，是世外桃源的诗意生活；
                    喧闹嘈杂的市井街巷，藏着不为人知的百年秘境…
                    你匆匆错过的，也许是这座城市最好玩的。
                    偶尔一次，放慢向远方探索的脚步吧，
                    换一种玩法，重新发现城市的乐趣。
                </p>
                <!--<p class="text-muted" id="textb" v-show="!textShow">-->
                    <!--C城市是诞生奇迹之所， 是人类最伟大的发明与最美好的希望。-->
                    <!--钢筋水泥的高楼之下，是平凡治愈的人间烟火；-->
                    <!--灯红酒绿的霓虹之外，是世外桃源的诗意生活；-->
                    <!--喧闹嘈杂的市井街巷，藏着不为人知的百年秘境…-->
                    <!--你匆匆错过的，也许是这座城市最好玩的。-->
                    <!--偶尔一次，放慢向远方探索的脚步吧，-->
                    <!--换一种玩法，重新发现城市的乐趣。-->
                    <!--...<span style="color: #E60012;cursor: pointer" id="look" @click="lookthis()">查看更多</span>-->
                <!--</p>-->
            </div>

            <div class="row" style="margin: 0 -26px;">
                <div class="col-xs-4" style="position: relative;">
                <span style="color: #ffffff;position: absolute;left:25%;top: 46%;font-size: 18px;letter-spacing: 3px;">上海●城市活动</span>
                <img src="https://alistatic.54traveler.com/werulepc/page2/pc2-1.png" @click="goSecond('上海')" style="height:220px;border-radius: 5px;cursor: pointer;">
                </div>
                <div class="col-xs-4" style="position: relative;">
                <span style="color: #ffffff;position: absolute;left:25%;top: 46%;font-size: 18px;letter-spacing: 3px;">北京●城市活动</span>
                <img src="https://alistatic.54traveler.com/werulepc/page2/pc2-2.png" @click="goSecond('北京')"style="height:220px;border-radius: 5px;cursor: pointer;">
                </div>
                <div class="col-xs-4" style="position: relative;">
                <span style="color: #ffffff;position: absolute;left:25%;top: 46%;font-size: 18px;letter-spacing: 3px;">广州●敬请期待</span>
                <img src="https://alistatic.54traveler.com/werulepc/page2/pc2-3.png" style="height:220px;border-radius: 5px;cursor: pointer;">
                </div>
            </div>

            <div class="row">
                <h2 style="text-align: center;font-weight: lighter;">前所未有的期待...</h2>
            </div>
            <div class="row" style="margin-left: -12px;margin-right: 2px;margin-bottom: 40px;">
                <img src="https://alistatic.54traveler.com/werulepc/gopc.jpg" style="width:100%;border-radius: 5px;cursor: pointer;" @click="gotour()">
            </div>


        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        textShow: false
      }
    },
    methods: {
      goSecond (city) {
        var url = '/city/' + city
        window.open(url)
      },
      gotour () {
        var url = process.env.TOUR_URL + '/route/El/?r=l'
        window.open(url)
      },
      lookthis () {
        this.textShow = true
      }
    }
  }
</script>
<style scoped>
  .container{
      width: 1000px;
  }
  .we-part{
      padding-top: 55px;
      padding-bottom: 80px;
  }
  .we-part img{
      width: 100%;
      height: 100%;
  }
  .we-part:nth-child(odd){
      background-color: #fff;
  }
  .we-part:nth-child(even){
      background-color: #fbfbfb;
  }
  .we-part .container:nth-child(2){
      padding: 0;
  }
  h2{
      font-weight: bold;
      margin-bottom: 20px;
      text-align: left;
      font-size: 24px;
  }
  .col-xs-10.col-xs-offset-1{
      margin-bottom: 45px;
  }
</style>



/** WEBPACK FOOTER **
 ** Mfirst.vue?624f868c
 **/